/**
 * Gestión central de consentimiento (sin dependencias).
 * Categorías: necesario (siempre), analítica (GA4), externo (Google Maps).
 */
export const CONSENT_KEY = "pymevisible:privacidad:v1";
export const CONSENT_EVENT = "pymevisible:consentimiento";
export const CONSENT_OPEN_EVENT = "pymevisible:abrir-preferencias";

const GA_ID = "G-7N5P6BHSPT";

export type Consentimiento = {
  version: 1;
  analitica: boolean;
  externo: boolean;
  fecha: string;
};

export const CONSENT_POR_DEFECTO: Consentimiento = {
  version: 1,
  analitica: false,
  externo: false,
  fecha: "",
};

export function leerConsentimiento(): Consentimiento | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(CONSENT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<Consentimiento>;
    if (parsed?.version !== 1) return null;
    return {
      version: 1,
      analitica: Boolean(parsed.analitica),
      externo: Boolean(parsed.externo),
      fecha: typeof parsed.fecha === "string" ? parsed.fecha : "",
    };
  } catch {
    return null;
  }
}

export function guardarConsentimiento(valor: { analitica: boolean; externo: boolean }) {
  if (typeof window === "undefined") return;
  const dato: Consentimiento = {
    version: 1,
    analitica: valor.analitica,
    externo: valor.externo,
    fecha: new Date().toISOString(),
  };
  try {
    window.localStorage.setItem(CONSENT_KEY, JSON.stringify(dato));
  } catch {
    /* si no hay almacenamiento disponible, el sitio no debe fallar */
  }
  aplicarConsentimiento(dato);
  window.dispatchEvent(new CustomEvent<Consentimiento>(CONSENT_EVENT, { detail: dato }));
}

export function hayAnalitica(): boolean {
  return leerConsentimiento()?.analitica === true;
}

export function hayExterno(): boolean {
  return leerConsentimiento()?.externo === true;
}

let gaCargado = false;

function cargarGA() {
  if (gaCargado || typeof document === "undefined") return;
  if (document.getElementById("ga4-script")) {
    gaCargado = true;
    return;
  }
  gaCargado = true;
  const s = document.createElement("script");
  s.id = "ga4-script";
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag(...args: unknown[]) {
    window.dataLayer!.push(args);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID);
}

/** Aplica el estado guardado: sólo carga GA cuando hay consentimiento analítico. */
export function aplicarConsentimiento(dato: Consentimiento | null = leerConsentimiento()) {
  if (dato?.analitica) cargarGA();
}

export function abrirPreferencias() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(CONSENT_OPEN_EVENT));
}
